app.factory('clinicModel', ['$rootScope', 'baseModel', 'clinicService',
    function($rootScope, baseModel, clinicService) {

        function ClinicModel() {

            this.getById = function(clinicId) {
                return clinicService.getById(clinicId).then(
                    function (clinic) {
                        $rootScope.$broadcast(Event.CLINIC.GET_BY_ID.SUCCESS, clinic);
                        return clinic;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.CLINIC.GET_BY_ID.ERROR, error);
                    }
                )
            };
        }

        return new ClinicModel();
    }
]);
